import React from 'react'
import { Box, IconButton, Typography, Chip } from '@mui/material'
import { styled, alpha } from '@mui/material/styles'
import { ArrowBack, Close, ChatBubbleOutline, FavoriteOutlined } from '@mui/icons-material'
import SVG from 'react-inlinesvg'
import { SVGS } from '@/assets/svgs'

const HeaderContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  backgroundColor: '#ffffff',
  borderBottom: '1px solid #e5e7eb',
})

const LeftSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
})

const BackButton = styled(IconButton)({
  width: '24px',
  height: '24px',
  padding: 0,

  '& svg': {
    fontSize: '20px',
    color: '#6b7280',
  },
})

const MainTitle = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#111827',
  lineHeight: 1.3,
})

const RightSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
})

const CountText = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#6b7280',
})

const CloseButton = styled(IconButton)({
  width: '24px',
  height: '24px',
  padding: 0,

  '& svg': {
    fontSize: '20px',
    color: '#6b7280',
  },
})

interface ModernCommentsHeaderProps {
  commentsCount: number
  likesCount?: number
  onBack: () => void
  onClose?: () => void
  showCounts?: boolean
  title?: string
  subtitle?: string
}

export function ModernCommentsHeader({
  commentsCount,
  likesCount = 0,
  onBack,
  onClose,
  showCounts = true,
  title,
  subtitle,
}: ModernCommentsHeaderProps) {
  return (
    <HeaderContainer>
      <LeftSection>
        <BackButton onClick={onBack}>
          <ArrowBack />
        </BackButton>

        <MainTitle>{title || 'Comments'}</MainTitle>
      </LeftSection>

      <RightSection>
        {onClose && (
          <CloseButton onClick={onClose}>
            <Close />
          </CloseButton>
        )}
      </RightSection>
    </HeaderContainer>
  )
}
